/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".booking-banner[_ngcontent-%COMP%]{background-size:cover;height:82px}"];
export { styles as styles };
